import React from "react";
/*
    For Redux, need to import connect and action
    Redux connect is to access Redux
    Redux action to update the state of the form field
*/
import { connect } from "react-redux";
import { updateForm, setStep } from "../../../store/actions/FormAction";
/*
    Importing React Scroll for animating scrolling down to elements
*/
import { animateScroll as scroll } from 'react-scroll';
/*
    Importing FontAwesome Icons for checkmark
*/
import FontAwesome from 'react-fontawesome';
/*
    Importing NextStepButton that is a component that updates the page in Redux
*/
import NextButton from "../../partials/NextButton";
/*
    Importing AlertDialogSlide for sliding Modal Window
*/
import AlertDialogSlide from "../../partials/AlertDialogSlide";
/*
    This page is using a template AccountLayout
*/
import StepLayout from '../../../containers/StepLayout';


/*
    Using Validation functions from utils folder
*/
import Validation from '../../../utils/Validation';
const validation = new Validation();

/*
    Checking all fields filled properly
    States are async so was not immediate response that I needed
*/
function checkAll(emailchecked,passwordchecked,econsentchecked) {
    if (emailchecked === true && passwordchecked === true && econsentchecked === true){
      return true;
    }
    return false;
}

/*
    CreateAccount view that displays the Create Account page
    Remember JSX requires you to use camelcasing of attributes
    (ie className vs 'class', htmlFor vs 'for', tabIndex vs tab-index)
    Remember JSX requires all tags be closed (ie: self closed <hr />, <br />)
    Create React App requires alt tags for all <img> elements (good for SEO too)
*/
class CreateAccount extends React.Component {
  constructor(props){
    super(props);

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleEConChange = this.handleEConChange.bind(this);
    this.handleEConsentChange = this.handleEConsentChange.bind(this);

    this.emailchecked = false;
    this.passwordchecked = false;
    this.econsentchecked = false;
  }

  componentDidMount() {
    this.props.updateForm("pagename", "Create Account");
    this.props.setStep(0);

    //TODO: need to grab email from API instead / throw some error?
    // email from state
    if (validation.validateEmail(this.props.eml)) {
      this.emailchecked = true;
      document.querySelector("label[for='eml']").classList.add("active");
      document.querySelector("label[for='pwd']").focus();
    } else if (this.props.eml.length === 0){
      //TODO FOR TESTING PURPOSES ONLY
      this.props.updateForm("eml", "johndoe@gmail.com");
      this.emailchecked = true;
      document.querySelector("label[for='eml']").classList.add("active");
      document.querySelector("label[for='pwd']").focus();
    }
    // password from state
    if (this.props.pwd2.length > 0){
      if (validation.hasLetter(this.props.pwd)){
        document.querySelector("#aletter .done").classList.remove("hidden");
        document.querySelector("#aletter .missing").classList.add("hidden");
        document.querySelector("#aletter").classList.add("allgood");
      } else {
        document.querySelector("#aletter .done").classList.add("hidden");
        document.querySelector("#aletter .missing").classList.remove("hidden");
        document.querySelector("#aletter").classList.remove("allgood");
      }
      if (validation.hasCapital(this.props.pwd)){
        document.querySelector("#acapital .done").classList.remove("hidden");
        document.querySelector("#acapital .missing").classList.add("hidden");
        document.querySelector("#acapital").classList.add("allgood");
      } else {
        document.querySelector("#acapital .done").classList.add("hidden");
        document.querySelector("#acapital .missing").classList.remove("hidden");
        document.querySelector("#acapital").classList.remove("allgood");
      }
      if (validation.hasNumber(this.props.pwd)){
        document.querySelector("#anumber .done").classList.remove("hidden");
        document.querySelector("#anumber .missing").classList.add("hidden");
        document.querySelector("#anumber").classList.add("allgood");
      } else {
        document.querySelector("#anumber .done").classList.add("hidden");
        document.querySelector("#anumber .missing").classList.remove("hidden");
        document.querySelector("#anumber").classList.remove("allgood");
      }
      if (validation.hasSpecial(this.props.pwd)){
        document.querySelector("#specialchar .done").classList.remove("hidden");
        document.querySelector("#specialchar .missing").classList.add("hidden");
        document.querySelector("#specialchar").classList.add("allgood");
      } else {
        document.querySelector("#specialchar .done").classList.add("hidden");
        document.querySelector("#specialchar .missing").classList.remove("hidden");
        document.querySelector("#specialchar").classList.remove("allgood");
      }
      if (this.props.pwd.length >= 8){
        document.querySelector("#minchar .done").classList.remove("hidden");
        document.querySelector("#minchar .missing").classList.add("hidden");
        document.querySelector("#minchar").classList.add("allgood");
      } else {
        document.querySelector("#minchar .done").classList.add("hidden");
        document.querySelector("#minchar .missing").classList.remove("hidden");
        document.querySelector("#minchar").classList.remove("allgood");
      }
      if (this.props.pwd2.length >= 8 && validation.validatePass(this.props.pwd2)) {
        this.passwordchecked = true;
        document.querySelector("label[for='pwd']").classList.add("activepass");
        document.querySelector("label[for='econsent']").focus();
      }
    }

    // econsent from state
    if (this.props.econsent2){

      this.econsentchecked = true;
      document.getElementById("econsent").checked = true;
    }
  }

  componentWillUnmount() {
    window.scrollTo(0, 0);
  }
  handleEmailChange(e) {
    let email = e.target.value;
    this.props.updateForm("eml", email);

    let emltip = document.getElementById("emltip");
    const emaillabel = document.querySelector("label[for='eml']");

    if (validation.validateEmail(email)) {
      this.emailchecked = true;
      emltip.innerHTML = "";
      emltip.classList.add("hidden");
      emaillabel.classList.add("active");
    } else {
      this.emailchecked = false;
      emaillabel.classList.remove("active");
    }
    this.props.updateForm("allchecked2", checkAll(true,this.emailchecked,this.passwordchecked,this.econsentchecked));
  }

  handleEmailBlur(e) {
    let email = e.target.value;
    let emltip = document.getElementById("emltip");

    if (email.length < 1) {
      emltip.innerHTML = "Please enter an email address.";
      emltip.classList.remove("hidden");
    } else if (!validation.validateEmail(email)) {
      emltip.innerHTML = email + " is not a valid email.";
      emltip.classList.remove("hidden");
    }
  }

  handlePasswordChange(e) {
    let password = e.target.value;
    this.props.updateForm("pwd2", password);

    let pwdtip = document.getElementById("pwdtip");
    const passlabel = document.querySelector("label[for='pwd']");

    if (validation.hasLetter(password)){
      document.querySelector("#aletter .done").classList.remove("hidden");
      document.querySelector("#aletter .missing").classList.add("hidden");
      document.querySelector("#aletter").classList.add("allgood");
    } else {
      document.querySelector("#aletter .done").classList.add("hidden");
      document.querySelector("#aletter .missing").classList.remove("hidden");
      document.querySelector("#aletter").classList.remove("allgood");
    }
    if (validation.hasCapital(password)){
      document.querySelector("#acapital .done").classList.remove("hidden");
      document.querySelector("#acapital .missing").classList.add("hidden");
      document.querySelector("#acapital").classList.add("allgood");
    } else {
      document.querySelector("#acapital .done").classList.add("hidden");
      document.querySelector("#acapital .missing").classList.remove("hidden");
      document.querySelector("#acapital").classList.remove("allgood");
    }
    if (validation.hasNumber(password)){
      document.querySelector("#anumber .done").classList.remove("hidden");
      document.querySelector("#anumber .missing").classList.add("hidden");
      document.querySelector("#anumber").classList.add("allgood");
    } else {
      document.querySelector("#anumber .done").classList.add("hidden");
      document.querySelector("#anumber .missing").classList.remove("hidden");
      document.querySelector("#anumber").classList.remove("allgood");
    }
    if (validation.hasSpecial(password)){
      document.querySelector("#specialchar .done").classList.remove("hidden");
      document.querySelector("#specialchar .missing").classList.add("hidden");
      document.querySelector("#specialchar").classList.add("allgood");
    } else {
      document.querySelector("#specialchar .done").classList.add("hidden");
      document.querySelector("#specialchar .missing").classList.remove("hidden");
      document.querySelector("#specialchar").classList.remove("allgood");
    }
    if (password.length >= 8){
      document.querySelector("#minchar .done").classList.remove("hidden");
      document.querySelector("#minchar .missing").classList.add("hidden");
      document.querySelector("#minchar").classList.add("allgood");
    } else {
      document.querySelector("#minchar .done").classList.add("hidden");
      document.querySelector("#minchar .missing").classList.remove("hidden");
      document.querySelector("#minchar").classList.remove("allgood");
    }

    if (password.length >= 8 && validation.validatePass(password)) {
      this.passwordchecked = true;
      pwdtip.innerHTML = "";
      pwdtip.classList.add("hidden");
      passlabel.classList.add("activepass");
    } else {
      this.passwordchecked = false;
      passlabel.classList.remove("activepass");
    }

    this.props.updateForm("allchecked2", checkAll(true,this.emailchecked,this.passwordchecked,this.econsentchecked));
  }

  handlePasswordBlur(e) {
    let password = e.target.value;
    let pwdtip = document.getElementById("pwdtip");
    const passlabel = document.querySelector("label[for='pwd']");

    if (password.length < 8){
      pwdtip.innerHTML = "Your password needs to be at least 8 characters.";
      pwdtip.classList.remove("hidden");
      passlabel.classList.remove("activepass");
    } else if (!validation.validatePass(password)) {
      if (validation.hasLetter(password)){
        if (validation.hasCapital(password)){
          if (!validation.hasNumber(password) && !validation.hasSpecial(password)){
            pwdtip.innerHTML = "Please add a number and a special character.";
          } else if (!validation.hasNumber(password)){
            pwdtip.innerHTML = "Please add a number.";
          } else {
            pwdtip.innerHTML = "Please add a special character.";
          }
        } else {
          pwdtip.innerHTML = "Please add a capital letter.";
        }
      } else {
        pwdtip.innerHTML = "Try adding a letter first.";
      }
      pwdtip.classList.remove("hidden");
      passlabel.classList.remove("activepass");
    }
  }

  handleEConChange(e) {

    this.econsentchecked = document.getElementById("econsent").checked;
    this.props.updateForm("econsent2", this.econsentchecked);
    if (this.econsentchecked && window.pageYOffset < 300){
      scroll.scrollTo(300, {duration: 1000});
    }
    this.props.updateForm("allchecked2", checkAll(true,this.emailchecked,this.passwordchecked,this.econsentchecked));
  }
  handleEConsentChange(e) {

    if (e.target.classList.contains("modalLink")){
      e.preventDefault();
    } else {
      this.econsentchecked = !document.getElementById("econsent").checked;
      this.props.updateForm("econsent2", this.econsentchecked);
      if (this.econsentchecked && window.pageYOffset < 300){
        scroll.scrollTo(300, {duration: 1000});
      }
      this.props.updateForm("allchecked2", checkAll(true,this.emailchecked,this.passwordchecked,this.econsentchecked));
    }
  }

  handleEyeClick(e){
    e.preventDefault();
    let passinput = document.getElementById("pwd");
    let x = document.getElementById("crossout");
    if (passinput.type === "password") {
        passinput.type = "text";
        x.classList.remove('hidden');
    } else {
        passinput.type = "password";
        x.classList.add('hidden');
    }
  }

  render() {

    const nextStep = 1;
    const nextLink = "/reachingyou";
    const btnText = "Create My Account";
    const btnClasses = "btn next-step";

    return (
      <StepLayout>
        <div className="container" id="stepper-step-2">
            <div className="text-center topcopy">
                <h1>Create your account</h1>
                <h5>To proceed with your secure application, please create a password.</h5>
            </div>
            <hr />
            <form className="flowform">
                <input type="hidden" value="needed for disabling autocomplete" />
                <div className="form-group">
                    <label htmlFor="eml" >
                        Email
                        <div className="errortip hidden" id="emltip">
                            Please provide a valid email address.
                        </div>
                        <input type="email" name="eml" id="eml" autoComplete="eml" className="form-control" tabIndex="1" value={this.props.eml} onChange={this.handleEmailChange} onBlur={this.handleEmailBlur} /> <div className="nothuman"><input type="email" name="email" /></div>
                    </label>
                </div>
                <div className="form-group">
                    <label htmlFor="pwd">
                        Create password
                        <div className="errortip hidden" id="pwdtip">
                            Try adding a number or special character.
                        </div>
                        <input type="password" name="pwd" id="pwd" autoComplete="pwd" className="form-control" tabIndex="2" value={this.props.pwd2} onChange={this.handlePasswordChange} onBlur={this.handlePasswordBlur} />
                        <a className="allseeing" onClick={this.handleEyeClick} >
                          <svg width="22px" viewBox="0 0 22 22">
                              <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-227.000000, -346.000000) translate(229.000000, 348.000000)">
                                  <path d="M10.0001136,2 C5.21617662,2 1.19200936,4.75570577 0,8.5 C1.19200936,12.2445411 5.21640376,15 9.99988643,15 C14.7838234,15 18.8079906,12.2442942 20,8.5 C18.8079906,4.75545893 14.7838234,2 10.0001136,2 Z M10.0755227,13.0924315 C7.70240651,13.0924315 5.77879232,11.0019557 5.77879232,8.42298637 C5.77879232,5.84401701 7.70240651,3.75354118 10.0755227,3.75354118 C12.4484118,3.75354118 14.3722531,5.84401701 14.3722531,8.42298637 C14.3722531,11.0019557 12.4484118,13.0924315 10.0755227,13.0924315 Z" id="Shape" fill="#7F868A" fillRule="nonzero"></path>
                                  <g id="crossout" strokeLinecap="round" className="hidden">
                                      <path stroke="#FFFFFF" strokeWidth="4" d="M0,18 L18,0"></path>
                                      <path stroke="#7F868A" strokeWidth="2" d="M0,18 L18,0"></path>
                                  </g>
                              </g>
                          </svg>
                        </a> <div className="nothuman"><input type="password" name="password" /></div>
                    </label>
                    <div className="hint animated popIn" id="pwdhint">
                        Your password requires the following:
                        <p id="minchar" style={{marginBottom:0,marginLeft:20}}><FontAwesome className='done hidden' name="check" style={{color:'green',marginRight:'4px'}}/><FontAwesome className='missing' name='circle' style={{fontSize:'12px',marginTop:'-1px',marginRight:'6px'}} /> is at least 8 characters</p>
                        <p id="aletter" style={{marginBottom:0,marginLeft:20}}><FontAwesome className='done hidden' name="check" style={{color:'green',marginRight:'4px'}} /><FontAwesome className='missing' name='circle' style={{fontSize:'12px',marginTop:'-1px',marginRight:'6px'}} /> contains a letter</p>
                        <p id="acapital" style={{marginBottom:0,marginLeft:20}}><FontAwesome className='done hidden' name="check" style={{color:'green',marginRight:'4px'}} /><FontAwesome className='missing' name='circle' style={{fontSize:'12px',marginTop:'-1px',marginRight:'6px'}} /> contains a capital letter</p>
                        <p id="anumber" style={{marginBottom:0,marginLeft:20}}><FontAwesome className='done hidden' name="check" style={{color:'green',marginRight:'4px'}} /><FontAwesome className='missing' name='circle' style={{fontSize:'12px',marginTop:'-1px',marginRight:'6px'}} /> contains a number</p>
                        <p id="specialchar" style={{marginBottom:0,marginLeft:20}}><FontAwesome className='done hidden' name="check" style={{color:'green',marginRight:'4px'}} /><FontAwesome className='missing' name='circle' style={{fontSize:'12px',marginTop:'-1px',marginRight:'6px'}} /> contains a special character</p>
                    </div>
                </div>
                <h5>Terms</h5>
                <div className="errortip hidden">
                    Please accept the terms.
                </div>
                <div className="checkbox checkbox-circle">
                    <input type="checkbox" id="econsent" name="econsent" className="styled" tabIndex="3x" onChange={this.handleEConChange} />
                    <label htmlFor="econsent" checked={this.props.econsent2} onClick={this.handleEConsentChange}>I confirm I have read and agree to the <AlertDialogSlide linkText="Electronic Communications Agreement" tip="econsent"/> and agree to receive electronic disclosures and transact business electronically.</label>
                </div>

                <p>By clicking &#39;Create my account&#39; I agree to MoneyKey&#39;s <AlertDialogSlide linkText="Terms of Use" tip="termsofuse"/>, <AlertDialogSlide linkText="Privacy Policy" tip="privacypolicy"/> and <AlertDialogSlide linkText="Arbitration Agreement" tip="arbitration"/>.</p>
                <p>I also confirm that I am a resident of the United States and of legal age to contract in my State of residence.</p>

                <NextButton next={nextLink} btnText={btnText} btnClasses={btnClasses} disableNext={!this.props.allchecked2} step={nextStep} tabIndex="4" id="allchecked"/>

            </form>
        </div>
      </StepLayout>
      );
    }
}


const mapStateToProps = (state) => ({
    eml: state.FormReducer.eml,
    pwd2: state.FormReducer.pwd2,
    econsent2: state.FormReducer.econsent2,
    allchecked2: state.FormReducer.allchecked2
})

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value)),
    setStep: (step) => dispatch(setStep(step))
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateAccount)



// WEBPACK FOOTER //
// ./src/components/views/CreateAccount/index.js